<template>
  <ul class="flex gap-4">
    <li v-for="link in links" :key="link.url">
      <a :href="link.url" target="_blank">
        <img loading="lazy" :src="link.icon" :alt="link.title" />
      </a>
    </li>
  </ul>
</template>

<script setup>
import links from "static/footer-social.ts"
</script>

<style lang="scss" scoped></style>
